/**
 * cart-cross-sell custom element
 * Charge des recommandations complémentaires dans le drawer panier
 * et permet l'ajout direct sans quitter le drawer.
 */
(function () {
  if (customElements.get('cart-cross-sell')) return;

  class CartCrossSell extends HTMLElement {
    constructor() {
      super();
      this.loaded = false;
    }

    connectedCallback() {
      // Charger uniquement quand le drawer s'ouvre, pour ne pas alourdir la home.
      const drawer = this.closest('cart-drawer');
      if (drawer && drawer.classList.contains('active')) {
        this.load();
      } else {
        // Observer l'ouverture
        const obs = new MutationObserver(() => {
          if (drawer && drawer.classList.contains('active') && !this.loaded) {
            this.load();
          }
        });
        if (drawer) obs.observe(drawer, { attributes: true, attributeFilter: ['class'] });
        // Fallback : charger après 500ms si pas de drawer parent
        setTimeout(() => { if (!this.loaded) this.load(); }, 800);
      }
    }

    async load() {
      if (this.loaded) return;
      this.loaded = true;
      const url = this.dataset.url;
      if (!url) return;
      try {
        const res = await fetch(url);
        if (!res.ok) return;
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const inner = doc.querySelector('.cart-cross-sell__inner');
        if (inner) {
          this.innerHTML = '';
          this.appendChild(inner);
          // Récupérer aussi le <style> associé
          const style = doc.querySelector('style');
          if (style) document.head.appendChild(style.cloneNode(true));
          this.bindForms();
        }
      } catch (e) { /* silencieux */ }
    }

    bindForms() {
      const forms = this.querySelectorAll('[data-cross-sell-form]');
      forms.forEach((form) => {
        form.addEventListener('submit', async (e) => {
          e.preventDefault();
          const formData = new FormData(form);
          const btn = form.querySelector('button');
          if (btn) { btn.disabled = true; btn.textContent = '✓'; }

          const sectionsToBundle = [];
          const drawer = document.querySelector('cart-drawer');
          if (drawer && drawer.getSectionsToRender) {
            drawer.getSectionsToRender().forEach((s) => sectionsToBundle.push(s.section));
          }
          if (sectionsToBundle.length) {
            formData.append('sections', sectionsToBundle.join(','));
            formData.append('sections_url', window.location.pathname);
          }

          try {
            const res = await fetch(window.routes.cart_add_url, {
              method: 'POST',
              headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' },
              body: formData
            });
            const data = await res.json();
            if (data.status) {
              // Erreur Shopify
              if (btn) { btn.disabled = false; btn.textContent = '+'; }
              return;
            }
            // Notifier le drawer pour rafraîchir l'affichage
            if (drawer && drawer.renderContents) {
              drawer.renderContents(data);
            }
            document.dispatchEvent(new CustomEvent('cart:add', { detail: data }));
            if (window.publish && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
              window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'cart-cross-sell', cartData: data });
            }
            // Rétablir le bouton après 1s
            setTimeout(() => { if (btn) { btn.disabled = false; btn.textContent = '+'; } }, 1000);
          } catch (err) {
            if (btn) { btn.disabled = false; btn.textContent = '+'; }
          }
        });
      });
    }
  }

  customElements.define('cart-cross-sell', CartCrossSell);
})();
